/*
    This file is only for JS which is required GLOBALLY. Otherwise it should probably have its own file, so that it can be easily disabled, copied, chunked, etc.
*/

window.ww; // window width
window.wh; // window height
window.hh; // header height (calculated in browser)
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.scrollDirection = "down"; // default
window.st = window.pageYOffset || document.documentElement.scrollTop;
var $header = $("#header");

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Scroll Events
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

var mainScrollEvent = function () {
  refreshScrollData();

  // Scroll-to-top link
  //if (lastScrollTop > 450) {
  //    $('.scrollToTop').fadeIn();
  //} else {
  //    $('.scrollToTop').fadeOut();
  //}

  $header.removeClass("down up").addClass(window.scrollDirection);
};

// optimized event handler: https://web.dev/uses-passive-event-listeners/
document.addEventListener('scroll', mainScrollEvent, {
  passive: true
});
function refreshScrollData() {
  // Gets the scrollTop and direction and updates the global variables accordingly
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  if (window.st > lastScrollTop) {
    window.scrollDirection = "down";
  } else {
    window.scrollDirection = "up";
  }

  //if (window.st <= window.hh) {
  //    $header.addClass("near-top");
  //} else {
  //    $header.removeClass("near-top");
  //}

  if (window.st === 0) {
    $header.addClass("top");
  } else {
    $header.removeClass("top");
  }
  window.lastScrollTop = window.st <= 0 ? 0 : window.st; // For Mobile or negative scrolling
}
refreshScrollData(); // run once at on load

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Kendo Tabstrip
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function setupTabstrips() {
  var $tabstrips = $(".tabstrip");
  if (!$tabstrips.length) {
    return;
  }
  var tabstrip = $tabstrips.each(function () {
    $(this).kendoTabStrip({
      tabPosition: "top",
      scrollable: false,
      animation: {
        open: {
          effects: "fadeIn"
        }
      },
      select: function (e) {
        let $target = $(e.item).find(".mPS2id-target").eq(0);
        let id = $target.attr("id");
        //debugger;
        $(".mPS2id-active-tab").removeClass("mPS2id-active-tab"); //.removeClass("mPS2id-clicked");

        let $link = $(`.__mPS2id[href='#${id}']`);
        $link.addClass("mPS2id-active-tab mPS2id-clicked");
      }
    });
  }).data("kendoTabStrip");
  tabstrip.select(0); // select and expand the first item
}
setupTabstrips();

// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Kendo Panelbar
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Setup panelbar lists (join us / students pages)
function setupPanelBars() {
  var $panelbarItems = $(".panelbarTitle");
  if (!$panelbarItems.length) {
    return;
  }
  $panelbarItems.each(function () {
    var $listView = $(this).closest("ul.listView").not(".k-panelbar");
    $listView.uniqueId(); // this is important - keyboard nav doesn't work properly without it
    if ($listView.length) {
      var panelbar = $listView.kendoPanelBar({
        expandMode: "single"
      }).data("kendoPanelBar");
      $listView.find(".k-icon").append('<span class="fa-sharp fa-light fa-plus"></span><span class="fa-sharp fa-light fa-minus"></span>');
      panelbar.expand(".k-first").select(".k-first"); // expand the first item
    }
  });
}
setupPanelBars();

// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Audio (Name pronunciation)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

if (!utils.isSitefinityEditor()) {
  $(document).on("click", ".audioFile a", function () {
    playAudio($(this).attr("data-audioid"));
    return false;
  }).on("keypress", ".audioFile a", function (e) {
    if (e.which === 13) {
      // enter key code
      playAudio($(this).attr("data-audioid"));
      return false;
    }
  });
}

// Play Audio
function playAudio($audioid) {
  var audioFile = $('#' + $audioid).addClass("playing").get(0).play();
}

// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Clickable class
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Clickable items (e.g. a clickable article card with nested links)

if (!utils.isSitefinityEditor()) {
  $(document).on("click", ".clickable", function (event) {
    var $this = $(this);

    // If there's not data-url, then find the first child el with an href and use that
    var itemUrl = "";
    var target = "_self"; // default

    // allow links within to work
    if ($(event.target).is('a[href]')) {
      return;
    }

    // First check for data atts. If none, use the first child link
    else if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
      itemUrl = $this.data("url");
      if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
        target = $this.data("target");
      }
    } else {
      var $firstLinkFound = $this.find("a[href]").first();
      itemUrl = $firstLinkFound.attr("href");
      target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
    }
    window.open(itemUrl, target);
  });
}

// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Intersection Observer (global)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function registerDefaultIntersectionObserver() {
  function observerCallback(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('inViewport');
      }
    });
  }

  // This should basically ALWAYS be set to 0. If you are trying to delay the animation, then  you need to use an offset instead.
  let observerOptions = {
    threshold: 0
  };
  var observer = new IntersectionObserver(observerCallback, observerOptions);
  let wrapperTarget = '.openStreetMap:not(.observed)'; //stop adding inViewPort to templates during editing
  document.querySelectorAll(wrapperTarget).forEach(i => {
    if (i) {
      i.classList.add("observed");
    }
  });
  if (!!window.IntersectionObserver) {
    //check if browser supports it, 
    document.querySelectorAll(wrapperTarget).forEach(i => {
      if (i) {
        observer.observe(i);
      }
    });
  } else {
    // if not, unhide everything
    document.querySelectorAll(wrapperTarget).forEach(i => {
      if (i) {
        i.classList.add('forceShow');
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', registerDefaultIntersectionObserver);

// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////